import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Menu from '../menu/Menu';
import RTButton from '../common/RTButton';
import ViewClosedComplaints from './ViewClosedComplaints';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ComplaintManagement.css';

const ViewComplaintsHistory = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="rt-layout">
      <Menu className="rt-menu" activePath={location.pathname} />
      <div className="rt-main-content">
        <div className="rt-title-row">
          <h2 className="rt-title">Complaints History</h2>
          <div className="rt-actions">
            <RTButton variant="secondary" onClick={() => navigate(-1)}>
              ← Back
            </RTButton>
          </div>
        </div>
        
        <div className="rt-main-section">
          <ViewClosedComplaints loadData={true} />
        </div>
      </div>
    </div>
  );
};

export default ViewComplaintsHistory;